import { cn } from '@/lib/cn';

export function BrandMark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" className={cn('shrink-0', className)}>
      <rect width="32" height="32" rx="8" fill="rgb(var(--color-primary))" />
      <path
        d="M16 7a9 9 0 1 0 5.2 16.35l2.4 2.4 2.1-2.1-2.4-2.4A9 9 0 0 0 16 7Zm0 3.2a5.8 5.8 0 1 1 0 11.6 5.8 5.8 0 0 1 0-11.6Z"
        fill="#fff"
      />
    </svg>
  );
}

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-2.5">
      <BrandMark />
      {!compact && (
        <div className="leading-tight">
          <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-ink">Quds Technology</p>
          <p className="text-[13px] text-ink-secondary">Admin Console</p>
        </div>
      )}
    </div>
  );
}
